// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"73b6c0e7","233":"a97d0420","369":"4ddf2a08","777":"d85915b3","936":"bda37461"}[chunkId] + ".js";
};